import * as types from "./type"

export const startCall = (phone) => ({
    type: types.START_CALL_PHONE,
    payload: phone
})

export const endCallPhone = () => ({
    type: types.END_CALL
})